import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import CatchImage from '../../images/catch/catch_tobe.jpg';
import CatchImage2x from '../../images/catch/catch_tobe@2x.jpg';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const ToBeDonorPage: React.FC = () => {
  useTitle('Ton Bébé | ドナーになるには');
  useMetaDescription('精子ドナーになるには？登録条件、性病・精液検査結果の登録方法、公開までの流れをTon Bébéが詳しく解説します。');

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="ドナーになるには"
          />
        </div>
      </header>
      <main className="sub">
        <section className="tobe">
          <h1 className="sec_title">ドナーになるには</h1>
          <ul className="text_list">
            <li>
              <h2 className="main_title"><span>精子ドナーになるにはどうしたらいいの？</span></h2>
              <p>新規登録より登録してください。</p>
              <p>Ton Bébéは妊娠を望む女性により多くの選択肢を提供し、より良い判断を支援するために精子ドナーおよび精子提供ボランティの登録を広く受け付けています。</p>
              <Link to="/register#donor" className="w_bluebtn">新規登録を行う</Link>
            </li>
            <li>
              <h2 className="main_title"><span>登録条件について</span></h2>
              <p>
                以下の条件に当てはまる男性であればどなたでも登録可能です。<br/>・心身ともに健康で、性病などの罹患がない方<br/>・遺伝病等の子供への影響があるとされる病気がない方<br/>・精子提供後に女性へ自らコンタクトをしないとお約束できる方<br/>・安易な性行為や金銭目的ではなく、妊娠を望む女性を心から支援できる方<br/>・一般的な言動やマナーに気を使い、人とのコミュニケーションがとれる方
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>性病検査・精液検査の結果登録について</span></h2>
              <p>
                提供を受ける女性が安心してドナーを探せるよう、ドナーの方には性病検査および精液検査の結果をご登録いただくようお願いしております。<br/>ご登録の際に検査結果書類の画像（検査結果証もしくはウェブ画面のスクリーンショット）を合わせてご提出いただき、当サービス運営事務局にて内容を確認いたします。
              </p>
              <p>確認が取れた後、女性ユーザー様が検査結果の値を閲覧できるようになります。<br/>（書類の画像が公開されることはありません。）</p>
              <div className="kit_cards">
                <div className="kit_card">
                  <img
                    src="//thumbnail.image.rakuten.co.jp/@0_gold/std-checker/img/type_Em_01.png"
                    alt="性病検査キット"
                    className="kit_card_img"
                  />
                  <div className="kit_card_body">
                    <p className="kit_card_name">性病検査キット</p>
                    <p className="kit_card_desc">HIV・梅毒・クラミジア・淋菌など主要な性病を自宅で検査できます。</p>
                    <div className="kit_card_btnarea">
                      <a
                        href="//af.moshimo.com/af/c/click?a_id=1784748&p_id=54&pc_id=54&pl_id=616&url=https%3A%2F%2Fitem.rakuten.co.jp%2Fstd-checker%2Ftype_em%2F&m=http%3A%2F%2Fm.rakuten.co.jp%2Fstd-checker%2Fi%2F10000007%2F"
                        rel="nofollow"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="kit_shop_btn rakuten"
                      >楽天市場で購入</a>
                      <a
                        href="//af.moshimo.com/af/c/click?a_id=1784765&p_id=170&pc_id=185&pl_id=4062&url=https%3A%2F%2Fwww.amazon.co.jp%2Fdp%2FB00JP4EFWG"
                        rel="nofollow"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="kit_shop_btn amazon"
                      >Amazonで購入</a>
                    </div>
                  </div>
                </div>
                <div className="kit_card">
                  <img
                    src="//thumbnail.image.rakuten.co.jp/@0_mall/onlinekensaoes/cabinet/akh.jpg"
                    alt="精液検査キット"
                    className="kit_card_img"
                  />
                  <div className="kit_card_body">
                    <p className="kit_card_name">精液検査キット</p>
                    <p className="kit_card_desc">精子濃度・運動率などを自宅で検査できます。</p>
                    <div className="kit_card_btnarea">
                      <a
                        href="//af.moshimo.com/af/c/click?a_id=1784748&p_id=54&pc_id=54&pl_id=616&url=https%3A%2F%2Fitem.rakuten.co.jp%2Fonlinekensaoes%2F0001%2F&m=http%3A%2F%2Fm.rakuten.co.jp%2Fonlinekensaoes%2Fi%2F10000000%2F"
                        rel="nofollow"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="kit_shop_btn rakuten"
                      >楽天市場で購入</a>
                      <a
                        href="//af.moshimo.com/af/c/click?a_id=1784765&p_id=170&pc_id=185&pl_id=4062&url=https%3A%2F%2Fwww.amazon.co.jp%2Fdp%2FB00G4UA1PE"
                        rel="nofollow"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="kit_shop_btn amazon"
                      >Amazonで購入</a>
                    </div>
                  </div>
                </div>
              </div>
              <p>※上記商品はどちらもTon Bébéの入力必須項目を満たしております。</p>
            </li>
            <li>
              <h2 className="main_title"><span>入会金・月額料金について</span></h2>
              <p>
                当サービスに入会金はありませんが、検査結果の確認手数料として性病・精液検査それぞれ3,000円ずつ（両方同時の場合は5,000円）をお支払いただいております。検査結果が正当であると弊社にて審査の後、ドナープロフィールの一部として検査結果が表示されます。
              </p>
              <p>検査結果の有効性は検査日から１年としており、１年以内に再検査の上、再度提出をお願いします。再提出には改めて上記料金が発生します。期限が切れた場合は、検査結果が表示されなくなりますのでご注意ください。</p>
              <p>検査結果の提出なしでも当サービスの利用は可能ですが、女性により安心してご指名いただくために提出をお勧めします。</p>
            </li>
            <li>
              <h2 className="main_title"><span>登録から公開までの流れ</span></h2>
              <h3 className="sub_title">STEP1. 新規登録</h3>
              <p><Link to="/register#donor">新規登録画面</Link>よりドナー登録を行なってください。</p>
            </li>
            <li>
              <h3 className="sub_title">STEP2. プロフィールの項目を入力し、公開する</h3>
              <p>マイページより生年月日や血液型などプロフィール情報を入力してください。自己紹介には、精子提供への想いなどを記入し、ドニーへの誠実さが伝わる文章を心がけましょう。</p>
            </li>
            <li>
              <h3 className="sub_title">STEP3. 性病検査結果・精液検査結果の入力・書類の提出</h3>
              <p>検査結果登録画面にて、性病や精液検査の結果を登録し、必要書類を添付して提出します。</p>
            </li>
            <li>
              <h3 className="sub_title">STEP4. 運営事務局にて確認</h3>
              <p>ご提出いただいた内容を運営事務局にて確認します。確認には通常、３営業日ほどいただいております。</p>
            </li>
            <li>
              <h3 className="sub_title">STEP5. 提出内容に不備がなければ事務局が承認し、公開</h3>
              <p>ご提出内容に不備がなければ、承認します。承認後、ご自身のプロフィールに表示されるようになります。</p>
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ToBeDonorPage;
